import React, { type FC } from 'react';

import styled from '@mint-lib/styled';

import { Truncation } from '@myn/mui';

import { EXPANDER_WIDTH } from './NameTextField.jsx';

type Props = {
  width: number;
  label: string;
  scale: number;
};

const PLatformLabel: FC<Props> = ({ label, width, scale }) => {
  return (
    <TruncatedPlatformLabel width={width} tooltipTitle={label} scale={scale}>
      {label}
    </TruncatedPlatformLabel>
  );
};

export default PLatformLabel;

const TruncatedPlatformLabel = styled(Truncation)<{
  width: number;
  scale: number;
}>`
  max-width: ${({ width }) => `${width - EXPANDER_WIDTH}px`};
  font-size: ${({ scale }) => `${scale * 0.875}rem`};
  line-height: ${({ scale }) => `${scale * 1}rem`};
`;
